// signaling WS で受信した生データを SignalingMessage として安全に解釈する。
// JSON でない / type を持たない不正入力は null を返し、呼び出し側が
// 無検証キャスト (as SignalingMessage) を避けられるようにする。

import type { SignalingMessage } from "../types.js";

export function parseSignalingMessage(raw: unknown): SignalingMessage | null {
  if (typeof raw !== "string") return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }
  if (typeof parsed !== "object" || parsed === null) return null;
  if (typeof (parsed as { type?: unknown }).type !== "string") return null;
  // type が string であることのみ検証する。個別ペイロードの妥当性は
  // 受信側の switch (未知 type は default で無視) に委ねる。
  return parsed as SignalingMessage;
}
